__turbopack_context__.v({
  "container": "ihi-Qq_container",
  "gallery": "ihi-Qq_gallery",
  "galleryContainer": "ihi-Qq_galleryContainer",
  "shimmer": "ihi-Qq_shimmer",
  "skeletonImage": "ihi-Qq_skeletonImage",
  "skeletonTitle": "ihi-Qq_skeletonTitle",
});
